app.service('sufficientOutletCategory', function (
	modal,
	sufficientCarouselPreview,
) {
	let previewModal;
	let $modal;

	function loadSingleProductForAccountPreview(data) {
		return $.ajax({
			url: '/web-cached/individual-outlet-offer-account-preview.ltr',
			data
		});
	}

	function initPreviewGallery(startIndex) {
		sufficientCarouselPreview.init(startIndex);
	}

	function handleModalOpen(startIndex = 0) {
		$addToCartButton = $modal.find('.add-to-cart');
		initPreviewGallery(startIndex);
	}

	function showPreviewModal(content, position) {
		previewModal = modal.generate({
			id: 'sufficient-product-preview',
			cssClass: 'sufficient-product-preview',
			callbackOpen: function() {
				$modal = this.$modal;
				handleModalOpen(position);
			},
			content
		});
	}

	function showErrorModal(xhr) {
		const errorMessage = `${xhr.status}: ${xhr.statusText}`;

		modal.alert(errorMessage);
	}

	function responseHasErrors(html) {
		return $(html).filter('.error-message').length;
	}

	function showResponseModal(html, position) {
		if (responseHasErrors(html)) {
			modal.alert(html);
		} else {
			showPreviewModal(html, position);
		}
	}

	function showIndividualOfferForAccountPreview(data) {
		loadSingleProductForAccountPreview(data)
			.then(html => showResponseModal(html, 0))
			.fail(showErrorModal);
	}

	function handleOutletProductPreviewClick(e) {
		e.preventDefault();

		const data = {
			huCode: $(this).data('code')
		};

		showIndividualOfferForAccountPreview(data);
	}

	function setEvents() {
		$('body')
			.on('click', '.js-outlet-product-preview', handleOutletProductPreviewClick)
	}

	function init() {
		setEvents();
	}

	return {
		init
	};
});
